export const founders = [
  {
    id: 1,
    name: "Familia Domínguez Santana",
    role: "Fundadores",
    bio: "San7o Pecado nació el 24 de enero de 2022 como un emprendimiento familiar creado por la familia Domínguez Santana, con el sueño de llevar postres accesibles, innovadores y personalizados a cada celebración.",
    image: "https://readdy.ai/api/search-image?query=happy%20mexican%20family%20smiling%20together%20in%20a%20cozy%20bakery%2C%20warm%20natural%20lighting%2C%20cheerful%20and%20proud%2C%20professional%20portrait%20photography%2C%20pastel%20colors%20background%2C%20elegant%20casual%20attire&width=300&height=300&seq=founder1&orientation=squarish",
    instagram: "#",
    facebook: "#",
  },
];

export const milestones = [
  {
    year: "2022",
    title: "Nace San7o Pecado",
    description: "El 24 de enero de 2022, la familia Domínguez Santana funda San7o Pecado como un emprendimiento familiar con el sueño de ofrecer postres accesibles y personalizados.",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/1a32823737713956c40e86a344d919a2.png",
    imagePosition: "object-center",
  },
  {
    year: "2022",
    title: "Primeros Postres Personalizados",
    description: "Comenzamos a ofrecer pasteles, cupcakes, galletas, gelatinas y postres pequeños personalizados, posicionándonos como la opción práctica, linda y rica.",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/df89d8b907c43945f68ef11f426b8784.png",
    imagePosition: "object-bottom",
  },
  {
    year: "2023",
    title: "Expansión de Sucursales",
    description: "Gracias al amor de nuestros clientes, comenzamos a crecer rápidamente, abriendo nuevas sucursales y consolidándonos como referencia en pasteles personalizados.",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/6070cc7ea55e244baa8af9234e8f0806.png",
    imagePosition: "object-center",
  },
  {
    year: "2024",
    title: "Más de 9 Años de Experiencia",
    description: "Con más de 9 años de experiencia acumulada en el equipo, consolidamos nuestra propuesta de valor: innovación, personalización, practicidad y cercanía.",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/dc69cd8a1eda09ed10594e46bfe79751.png",
    imagePosition: "object-center",
  },
  {
    year: "2026",
    title: "36 Sucursales",
    description: "Alcanzamos 36 sucursales activas, llevando nuestros postres a más familias y celebraciones en toda la región.",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/876635a0df73f4f247548050603ef19a.png",
    imagePosition: "object-center",
  },
  {
    year: "2026",
    title: "XXVI Premio Nacional a la Franquicia",
    description: "La Asociación Mexicana de Franquicias nos reconoció como Marca Finalista del XXVI Premio Nacional a la Franquicia en la categoría Promesa, avalando nuestro liderazgo, calidad y compromiso. Ciudad de México, 4 de marzo de 2026.",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/730d73fdf0ca40cfe995b911f87fbb59.png",
    imagePosition: "object-center",
  },
];

export const stats = [
  { value: "9+", label: "Años de experiencia" },
  { value: "36", label: "Sucursales" },
  { value: "2022", label: "Año de fundación" },
  { value: "🇲🇽", label: "Orgullosamente Mexicana" },
];

export const valores = [
  {
    icon: "ri-service-line",
    title: "Servicio",
    description: "Hacer grata para nuestros clientes la compra de sus productos.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Integridad",
    description: "Ser honestos con la empresa y con nuestros clientes.",
  },
  {
    icon: "ri-heart-2-line",
    title: "Altruismo",
    description: "Impulsar y ayudar a las causas sociales que abrazamos.",
  },
  {
    icon: "ri-checkbox-circle-line",
    title: "Responsabilidad",
    description: "Comprometerse con la empresa y con nuestros clientes.",
  },
  {
    icon: "ri-hand-heart-line",
    title: "Respeto",
    description: "Comportarse con buenos modales y educación.",
  },
];

export const propuestaValor = [
  {
    icon: "ri-lightbulb-line",
    title: "Innovación",
    description: "Siempre en tendencia, con diseños y sabores que sorprenden.",
  },
  {
    icon: "ri-magic-line",
    title: "Personalización",
    description: "Creamos un pastel único para ti, a tu medida y estilo.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Practicidad",
    description: "Atendemos por redes sociales, con pago por transferencia o al recoger.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Cercanía",
    description: "Más de 30 puntos de venta para que siempre tengas uno cerca.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Relación Precio-Beneficio",
    description: "Postres de alta calidad desde $10, accesibles para todos.",
  },
];
